module.exports = __webpack_public_path__ + "img/car_00021.47928a58.jpg";